document.addEventListener('DOMContentLoaded', function() {
  const variantPickerSelector = document.getElementById('variant-main-picker-selector');
  if (variantPickerSelector) {
    setTimeout(() => {
      variantPickerSelector.style.display = 'block';
    }, 1200);
  }

  // Get current URL handle
  const urlParts = window.location.pathname.split('/');
  const handle = urlParts[urlParts.length - 1];

  // Only hide swatch-option1 if not on gift-card page
  if (handle && !handle.includes('gift-card')) {
    const observer = new MutationObserver(() => {
      const swatchOption1 = document.getElementById('swatch-option1');
      if (swatchOption1) {
        swatchOption1.style.display = 'none';
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});